import React from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const iconSize = { height: '100px', width: '100px' }

function LoadingState() {
  return (
    <div className="viewer-overlay">
      <Icon svgComponent={RotatingSpinner} color="primary" size={iconSize} notSpaced />
    </div>
  )
}

export default LoadingState
